import React from 'react';
import { Seo } from '../../components/Seo';
import { site } from '../../config/site';

export default function PrivacyPolicyPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${site.name} — Politique de confidentialité`,
    url: `${site.url}/politique-confidentialite`,
    inLanguage: 'fr-FR',
  };

  return (
    <>
      <Seo
        title="Politique de confidentialité"
        description="Politique de confidentialité LuckyBetFR: quelles données, pourquoi, et comment les gérer."
        canonicalPath="/politique-confidentialite"
        jsonLd={jsonLd}
      />

      <section className="lbf-container py-12 sm:py-16">
        <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">Politique de confidentialité</h1>
        <p className="mt-4 max-w-3xl text-sm text-zinc-200/85">
          Cette page explique comment LuckyBetFR traite les données. On vise un principe simple: collecter le minimum,
          rester transparent, laisser le contrôle à l’utilisateur.
        </p>

        <div className="mt-10 grid gap-4">
          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Données collectées</h2>
            <ul className="mt-4 grid gap-2 text-sm text-zinc-200/85">
              <li>- Données techniques de base (ex: type de navigateur) via cookies essentiels.</li>
              <li>- Préférences de consentement cookies (stockées localement).</li>
              <li>- Statistiques d’audience uniquement si tu l’actives dans la bannière cookies.</li>
            </ul>
          </div>

          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Finalités</h2>
            <ul className="mt-4 grid gap-2 text-sm text-zinc-200/85">
              <li>- Sécurité et fonctionnement du site.</li>
              <li>- Amélioration de l’expérience (performance, navigation).</li>
              <li>- Mesure d’audience (optionnelle) pour comprendre ce qui est utile.</li>
            </ul>
          </div>

          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Tes droits</h2>
            <p className="mt-3 text-sm text-zinc-200/85">
              Tu peux refuser les cookies non essentiels, les accepter, ou les personnaliser. Tu peux aussi effacer tes
              données locales via les paramètres de ton navigateur.
            </p>
          </div>
        </div>

        <div className="mt-10 text-xs text-zinc-400">
          Dernière mise à jour: 2025-12-17 • Domaine: <span className="font-semibold text-white/80">{site.domain}</span>
        </div>
      </section>
    </>
  );
}


